import PropTypes from "prop-types";

function SideMenu({ open, children, direction = "ltr" }) {
  const getSideMenuPosition = () => {
    switch (direction) {
      case "rtl":
        return open ? "right-0" : "-mr-5 -right-0 translate-x-full";

      case "ltr":
      default:
        return open ? "left-0" : "-ml-5 -left-0 -translate-x-full";
    }
  };

  const position = getSideMenuPosition();

  return (
    <div
      className={`
        z-30
        fixed
        h-full
        w-full
        inset-y-0
        shadow-lg
        bg-white
        transition
        duration-500
        tablet:max-w-25rem
        laptop:max-w-25rem
        desktop:max-w-25rem
        ${position}
      `}
    >
      {children}
    </div>
  );
}

SideMenu.propTypes = {
  open: PropTypes.bool,
  children: PropTypes.any,
  direction: PropTypes.oneOf(["rtl", "ltr"])
};

export default SideMenu;
